import { TFunction } from 'shared/i18n';
import { z } from 'zod';

import { Policy } from '../../models/policies';
import { HeaderProps } from './components/Header';
import type { PolicySingleModal } from './components/modals';
import { ModalType } from './components/modals';
import { PolicyAPVsProps } from './sections/PolicyAPVs/PolicyAPVs';
import { PolicyClaimsProps } from './sections/PolicyClaims/PolicyClaims';
import { PolicyCoverageProps } from './sections/PolicyCoverage/PolicyCoverage';
import { PolicyDetailsProps } from './sections/PolicyDetails/PolicyDetails.models';
import { PolicyDocumentsProps } from './sections/PolicyDocuments/PolicyDocuments.models';

export type BillingType = 'MONTH' | 'YEAR';

type OmitDefaultProps<T> = Omit<T, 'onOpenModal' | 'policyData'>;

export type PolicySingleGenericSectionProps = {
  onOpenModal: (modalType: ModalType) => void;
  policyData: Policy;
};

export type PolicySingleSection =
  | {
      id: 'POLICY_DETAILS';
      props: OmitDefaultProps<PolicyDetailsProps>;
    }
  | {
      id: 'POLICY_COVERAGE';
      props: OmitDefaultProps<PolicyCoverageProps>;
    }
  | {
      id: 'POLICY_CLAIMS';
      props: OmitDefaultProps<PolicyClaimsProps>;
    }
  | {
      id: 'POLICY_DOCUMENTS';
      props: OmitDefaultProps<PolicyDocumentsProps>;
    }
  | { id: 'POLICY_CHECKLISTS' }
  | {
      id: 'POLICY_GENERIC_SECTION';
      component: (props: PolicySingleGenericSectionProps) => JSX.Element | null;
    }
  | {
      id: 'POLICY_APVS';
      props: OmitDefaultProps<PolicyAPVsProps>;
    };

export interface PolicyConfig {
  header: HeaderProps;
  sections: PolicySingleSection[];
  modals?: PolicySingleModal[];
}

export type GetPolicyConfigArgs = [
  policy: Policy,
  t: TFunction,
  featureFlags?: Record<string, boolean>
];

export const GenericPolicyTypeSchema = z.object({
  header: z
    .object({
      title: z.string().optional(),
      backgroundColor: z.string().optional(),
      startDate: z.string().optional(),
    })
    .optional(),
});
